import {Injectable,} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {BaseService} from '../base/base.service';
import {DateUtilsBs} from "../base/utils/dateUtilsBs";
import { BsaOrderPlaceholderXBVO } from '../model/dto.models.imported';

@Injectable({
    providedIn: 'root'
})
export class OrdersState extends BaseService {

    public selectedPlaceholder : BehaviorSubject<BsaOrderPlaceholderXBVO>;
    public selectedKW: number[];
    private TAG_SELECTED_PLACEHOLDER = "OrdersState.SELECTED_PLACEHOLDER";
    private TAG_SELECTED_KW = "OrdersState.SELECTED_KW";

    /**
     * Constructor.
     */
    constructor() {
        super();

        // restore SELECTED_PLACEHOLDER
        let pJson = sessionStorage.getItem(this.TAG_SELECTED_PLACEHOLDER);
        let pPlaceholder: BsaOrderPlaceholderXBVO = JSON.parse(pJson);
        this.selectedPlaceholder = new BehaviorSubject<BsaOrderPlaceholderXBVO>(pPlaceholder);
        this.logd("State restored from sessionStore: " + pPlaceholder);

        // restore SELECTED_KW
        let pCurrentWeek = DateUtilsBs.getYearWeek(new Date());
        pJson = sessionStorage.getItem(this.TAG_SELECTED_KW);
        let pStoredYW = JSON.parse(pJson);
        if (pStoredYW) {
            // fix corrupted KW (SWD-4253)
            if (pStoredYW.year == 2024 && pStoredYW.week == 1) {
                this.saveKW(pCurrentWeek[0], pCurrentWeek[1]);
            } else {
                this.selectedKW = [pStoredYW.year, pStoredYW.week];
            }
        } else {
            this.saveKW(pCurrentWeek[0], pCurrentWeek[1]);
        }
    }

    /**
     * Publishes
     */
    public saveSelectedPlaceholder(aPlaceholder: BsaOrderPlaceholderXBVO) {
        this.logd("Incoming Placeholder stored");
        sessionStorage.setItem(this.TAG_SELECTED_PLACEHOLDER, JSON.stringify(aPlaceholder));
        this.selectedPlaceholder.next(aPlaceholder);
    }

    /**
     * Publishes
     */
    public loadSelectedPlaceholder(): BsaOrderPlaceholderXBVO {
        this.logd("Current Placeholder: " + this.selectedPlaceholder.getValue());
        return this.selectedPlaceholder.getValue();
    }

    /**
     * Publishes
     */
    public saveKW(aYear: number, aWeek: number) {
        this.selectedKW = [aYear, aWeek];
        let pJsonYW = {year: aYear, week: aWeek};
        sessionStorage.setItem(this.TAG_SELECTED_KW, JSON.stringify(pJsonYW));
    }

    /**
     * Publishes
     */
    public getKW(): number[] {
        return this.selectedKW;
    }


}
